export const AppConfig = {
  //server: "https://app.kelava.id/",
  // server: "https://dev.kelava.id/almuslim/",
  server: "https://ppdb.almuslim.or.id/",

  appVersion:"1.0.9.5-dev",
  appVersionCode:36,
};
